import React from "react";
import StockReportTable from "../../components/Report/StockReportTable";

const ReportStockReportPage: React.FC = () => <StockReportTable />;
export default ReportStockReportPage;
